import en from '../en/common';

export const common = {
  ...en,
  "home.awards.title": "مۇكاپات ۋە شەرەپلەر",
  "home.awards.pause": "مۇكاپاتلارنىڭ سىيرىلىشىنى توختىتىش",
  "home.awards.play": "مۇكاپاتلارنىڭ سىيرىلىشىنى داۋاملاشتۇرۇش",
  "home.awards.financialAlgorithm": "پۇل مۇئامىلە ئالگورىزىمىدىكى باشلامچى كارخانا",
  "home.awards.asiaPacificGold": "ئاسىيا تىنچ ئوكيان ئالتۇن سودىسىدىكى باشلامچى ماركا",
  "home.awards.preciousMetals": "قىممەتلىك مېتال سودىسىدىكى ئىشەنچلىك ماركا",
  "home.awards.digitalFinance": "رەقەملىك پۇل مۇئامىلە يېڭىلىق يارىتىشىغا تۆھپە قوشقان كارخانا",
  "home.awards.quantitativeTrading": "مىقدارلاشقان سودا تېخنىكىسىدىكى مۇنەۋۋەر كارخانا",
  'nav.home': 'باش بەت',
  'nav.trading': 'سودا',
  'nav.markets': 'بازارلار',
  'nav.news': 'خەۋەرلەر',
  'nav.about': 'بىز ھەققىدە',
  'nav.contact': 'ئالاقىلىشىڭ',
  'nav.login': 'كىرىش',
  'nav.register': 'تىزىملىتىش',
  'nav.license': 'ئىجازەتنامە',
  'hero.title': 'ئالىي دەرىجىلىك ئالتۇن ۋە كۈمۈش سودا سۇپىسى',
  'hero.subtitle': 'دۇنياۋى مەبلەغ سالغۇچىلارغا بىخەتەر ۋە كەسپىي قىممەتلىك مېتال سودىسى تەمىنلەيدىغان شياڭگاڭدا ئىجازەت ئالغان شىركەت',
  'hero.cta.start': 'سودىنى باشلاڭ',
  'hero.cta.learn': 'MT5 نى چۈشۈرۈڭ',
  'home.licenseHK': 'شياڭگاڭدا ئىجازەت ئالغان',
  'home.bankSec': 'بانكا دەرىجىلىك بىخەتەرلىك',
  'home.247s': '24/7 قوللاش',
  'home.global': 'دۇنياۋى نىشان',
  'home.tradingPlat': 'سودا سۇپىسى',
  'home.tradingWith': 'بىز بىلەن سودا قىلىڭ ',
  'home.exp': 'قىممەتلىك مېتال سودىسى ئۈچۈن لايىھەلەنگەن دۇنيادىكى ئەڭ ئىلغار سودا سۇپىسىنى ئىشلىتىڭ. MT5 ئورگان دەرىجىلىك قوراللار، چاقماق تېزلىكىدىكى ئىجرا ۋە ئەتراپلىق بازار تەھلىلى بىلەن تەمىنلەيدۇ.',
  'home.dlMT5': 'MT5 نى چۈشۈرۈڭ',
  'home.watchDemo': 'كۆرسەتمىنى كۆرۈڭ',
  'home.tradingIns': 'سودا قوراللىرى',
  'home.exeSpeed': 'ئىجرا سۈرئىتى',
  'home.mktAccess': 'بازارغا كىرىش',
  'home.uptime': 'نورمال ئىشلەش ۋاقتى',
  'home.allDevices': 'بارلىق ئۈسكۈنىلەردە ئىشلىتىلىدۇ',
  'home.mktInt': 'بازار ئۇچۇرى',
  'home.mktInt.desc': 'قىممەتلىك مېتال سودىسىغا تەسىر كۆرسىتىدىغان ھەقىقىي ۋاقىتتىكى ئىقتىسادىي ۋەقەلەر ۋە بازار خەۋەرلىرىدىن خەۋەردار بولۇڭ',
  'home.lastUpdate': 'ئاخىرقى يېڭىلانغان ۋاقىت',
  'home.ecoCal': 'ئىقتىسادىي كالېندار',
  'home.refresh': 'يېڭىلاش',
  'home.currency': 'پۇل بىرلىكى',
  'home.events': 'ۋەقەلەر',
  'home.previous': 'ئالدىنقى',
  'home.forecast': 'مۆلچەر',
  'home.actual': 'ئەمەلىي',
  'home.mktNews': 'بازار خەۋەرلىرى',
  'home.seeMore': 'تېخىمۇ كۆپ كۆرۈش',
  'home.ecoData': 'ئىقتىسادىي سانلىق مەلۇماتلار كۆپ خىل پۇل-مۇئامىلە سانلىق مەلۇمات تەمىنلىگۈچىلىرىدىن • بازار خەۋەرلىرى داڭلىق پۇل-مۇئامىلە نەشرلىرىدىن',
  'home.ac': 'ئىلغار گرافىك',
  'home.pta': '80 دىن ئارتۇق كۆرسەتكۈچ ۋە تەھلىل قورالى بىلەن كەسپىي تېخنىكىلىق تەھلىل',
  'home.mpa': 'كۆپ سۇپىلىق زىيارەت',
  'home.tsa': 'كومپيۇتېر، تور ۋە يانفون ئەپلىرىدە راۋان سودا قىلىڭ',
  'home.st': 'بىخەتەر سودا',
  'home.bls': 'شىفىرلانغان سانلىق مەلۇمات يوللاش ۋە ساقلاشقا ئىگە بانكا دەرىجىلىك بىخەتەرلىك',
  'home.247': '24/7 بازارغا كىرىش',
  'home.rtc': 'دۇنيا قىممەتلىك مېتال بازارلىرىغا كېچە-كۈندۈز سودا قىلىش ئىمكانىيىتى',
  'home.at': 'ئاپتوماتىك سودا',
  'home.ea': 'ئالگورىزىملىق ۋە ئاپتوماتىك سودا ئىستراتېگىيەلىرى ئۈچۈن Expert Advisor (EA)',
  'home.lfe': 'چاقماق تېزلىكىدىكى ئىجرا',
  'home.ull': 'رىقابەت كۈچىگە ئىگە سپرىد بىلەن ئىنتايىن تۆۋەن كېچىكىشلىك بۇيرۇق ئىجراسى',
  'features.title': 'نېمە ئۈچۈن سۇپىمىزنى تاللايسىز',
  'features.security.title': 'بانكا دەرىجىلىك بىخەتەرلىك',
  'features.security.desc': 'ئىلغار شىفىرلاش ۋە كۆپ قاتلاملىق بىخەتەرلىك كېلىشىملىرى مەبلىغىڭىزنى قوغدايدۇ',
  'features.licensed.title': 'تولۇق ئىجازەت ئالغان',
  'features.licensed.desc': 'تولۇق قائىدىگە ئۇيغۇن ۋە ئاشكارا باشقۇرۇلىدىغان شياڭگاڭ شىركىتى',
  'features.realtime.title': 'ھەقىقىي ۋاقىتتىكى سودا',
  'features.realtime.desc': 'ئەڭ ياخشى سودا پۇرسىتى ئۈچۈن نەق بازار سانلىق مەلۇماتى ۋە دەرھال ئىجرا',
  'features.support.title': '24/7 قوللاش',
  'features.support.desc': 'كەسپىي كۆپ تىللىق قوللاش ئەترىتى كېچە-كۈندۈز مۇلازىمەت قىلىدۇ',
  'features.lmd': 'نەق بازار سانلىق مەلۇماتى',
  'features.rtp': 'قىممەتلىك مېتاللارنىڭ ھەقىقىي ۋاقىتتىكى باھاسى',
  'markets.title': 'ھەقىقىي ۋاقىتتىكى بازار باھاسى',
  'markets.preciousMetals': 'قىممەتلىك مېتاللار',
  'markets.liveSubtitle': 'ئەڭ يېڭى كۆرسەتمە خاراكتېرلىك ئالتۇن ۋە كۈمۈش باھاسىنى بىر يەردە كۆرۈڭ.',
  'markets.status.delayed': 'كېچىكتۈرۈلگەن',
  'markets.status.live': 'نەق مەيدان',
  'markets.livePrice': 'نەق باھا',
  'markets.sell': 'سېتىش',
  'markets.buy': 'سېتىۋېلىش',
  'markets.dayHigh': 'كۈنلۈك يۇقىرى',
  'markets.dayLow': 'كۈنلۈك تۆۋەن',
  'markets.lastUpdate': 'ئاخىرقى يېڭىلانغان ۋاقىت',
  'markets.hongKongTime': 'شياڭگاڭ ۋاقتى',
  'markets.indicativeDisclaimer': 'باھالار پەقەت كۆرسەتمە خاراكتېرىدە بولۇپ، كېچىكىشى مۇمكىن ۋە سودا ئىجرا باھاسى ئەمەس.',
  'markets.informationDisclaimer': 'باھا ۋە بازار ئۇچۇرلىرى كۆرسەتمە خاراكتېرىدە بولۇپ، كېچىكىشى مۇمكىن. مەزمۇن پەقەت ئۇچۇر ئۈچۈن بولۇپ، مەبلەغ سېلىش مەسلىھەتى ھېسابلانمايدۇ.',
  'markets.gold': 'ئالتۇن',
  'markets.silver': 'كۈمۈش',
  'markets.platinum': 'پىلاتىنا',
  'markets.palladium': 'پاللادىي',
  'markets.price': 'باھا',
  'markets.change': 'ئۆزگىرىش',
  'markets.high': '24 سائەتلىك يۇقىرى',
  'markets.low': '24 سائەتلىك تۆۋەن',
  'markets.contractDetials': 'توختام تەپسىلاتى',
  'markets.contractDetials.desc': 'قىممەتلىك مېتاللارنىڭ ئەتراپلىق توختام ئۆلچىمى ۋە سودا شەرتلىرى',
  'markets.tradingExample': 'سودا مىسالى',
  'markets.goldExample': 'ئالتۇن سودا مىسالى',
  'markets.silverExample': 'كۈمۈش سودا مىسالى',
  'markets.instrument': 'قورال',
  'markets.lotSize': 'لوت مىقدارى',
  'markets.entPrice': 'كىرىش باھاسى',
  'markets.marReq': 'زۆرۈر كاپالەت پۇلى',
  'markets.pip': 'پىپ قىممىتى',
  'markets.pmt': 'قىممەتلىك مېتال سودىسى',
  'markets.ctt': 'قىممەتلىك مېتال سودىسىنىڭ سودا ماددىلىرى، شەرتلىرى ۋە ئۆلچەملىرى. ئالتۇن-كۈمۈش مەبلىغى ئۈچۈن توختام تەپسىلاتى، كاپالەت پۇلى تەلىپى ۋە خەۋپ باشقۇرۇشنى چۈشىنىڭ.',
  'markets.vts': 'سودا ئۆلچىمىنى كۆرۈڭ',
  'markets.dcd': 'توختام تەپسىلاتىنى چۈشۈرۈڭ',
  'markets.ec': 'ئىجرا سۈرئىتى',
  'markets.th': 'سودا ۋاقتى',
  'markets.ms': 'ئەڭ تۆۋەن سپرىد (پىپ)',
  'markets.ml': 'ئەڭ يۇقىرى لېۋېرېج',
  'markets.mr': 'كاپالەت پۇلى تەلىپى',
  'markets.lo': 'ئوخشىمىغان ھېسابات تۈرلىرىنىڭ لېۋېرېج تاللانمىسى ۋە كاپالەت پۇلى تەلىپى',
  'markets.leverage': 'لېۋېرېج',
  'markets.margin': 'كاپالەت پۇلى',
  'markets.mind': 'ئەڭ تۆۋەن ئامانەت',
  'markets.mc': 'كاپالەت پۇلى ھېسابلىغۇچ',
  'markets.gmc': 'ئالتۇن كاپالەت پۇلى ھېسابلاش',
  'markets.cp': 'ھازىرقى باھا',
  'markets.cv': 'توختام قىممىتى',
  'markets.smc': 'كۈمۈش كاپالەت پۇلى ھېسابلاش',
  'markets.rm': 'خەۋپ باشقۇرۇش',
  'markets.crm': 'مەبلىغىڭىزنى قوغدايدىغان ئەتراپلىق خەۋپ باشقۇرۇش قوراللىرى ۋە ئىستراتېگىيەلىرى',
  'markets.rtg': 'خەۋپكە چىدامچانلىق قوللانمىسى',
  'markets.rd': 'خەۋپنى ئاشكارىلاش',
  'markets.tpm': 'قىممەتلىك مېتال سودىسى زور زىيان خەۋپىگە ئىگە بولۇپ، بارلىق مەبلەغ سالغۇچىلارغا ماس كەلمەسلىكى مۇمكىن. ئۆتمۈشتىكى نەتىجە كەلگۈسىدىكى نەتىجىنى بىلدۈرمەيدۇ.',
  'markets.lcw': 'لېۋېرېج سىزگە پايدا ئېلىپ كېلىشىمۇ، زىيان يەتكۈزۈشىمۇ مۇمكىن. سودا قىلىشنى قارار قىلىشتىن بۇرۇن مەبلەغ سېلىش نىشانىڭىز، تەجرىبە سەۋىيەڭىز ۋە خەۋپكە بەرداشلىق بېرىش ئىقتىدارىڭىزنى ئەستايىدىل ئويلاڭ.',
  'markets.ysb': 'قىممەتلىك مېتال سودىسىغا مۇناسىۋەتلىك بارلىق خەۋپلەرنى بىلىشىڭىز، گۇمانىڭىز بولسا مۇستەقىل مالىيە مەسلىھەتچىسىدىن مەسلىھەت ئېلىشىڭىز كېرەك.',
  'markets.rfr': 'تولۇق خەۋپ ئاشكارىلاشنى ئوقۇڭ',
  'markets.cra': 'خەۋپ مەسلىھەتچىسى بىلەن ئالاقىلىشىڭ',
  'markets.tho': 'سودا ۋاقتى',
  'markets.moh': 'قىممەتلىك مېتال بازىرىنىڭ ئېچىلىش ۋاقتى ۋە دەم ئېلىش جەدۋىلى',
  'markets.wts': 'ھەپتىلىك سودا جەدۋىلى',
  'markets.note': 'ئەسكەرتىش',
  'markets.atad': 'بارلىق ۋاقىت GMT+8 بويىچە كۆرسىتىلىدۇ. چوڭ بايرام ۋە بازار داۋالغۇشى مەزگىلىدە سودا توختىتىلىشى مۇمكىن.',
  'markets.hs': 'دەم ئېلىش جەدۋىلى',
  'markets.mclo': 'بازار تاقاق',
  'markets.eclo': 'بالدۇر تاقاش',
  'markets.hn': 'دەم ئېلىش ئۇقتۇرۇشى',
  'markets.thm': 'دۆلەت بايراملىرىدا سودا ۋاقتى تەڭشىلىشى مۇمكىن. ئۆزگىرىش بولسا ئۇقتۇرۇشلىرىمىزنى تەكشۈرۈڭ.',
  'markets.cms': 'ھازىرقى بازار ھالىتى',
  'markets.mac': 'بازار ھازىر سودا ئۈچۈن ئوچۇق',
  'markets.st': 'مۇلازىمېتىر ۋاقتى (GMT+8)',
  'markets.ts': 'سودا ئۆلچىمى',
  'markets.dtc': 'ئالتۇن ۋە كۈمۈش قوراللىرىنىڭ تەپسىلىي سودا شەرتى ۋە ئۆلچىمى',
  'markets.msp': 'ئەڭ تۆۋەن سپرىد',
  'markets.minls': 'ئەڭ تۆۋەن لوت',
  'markets.maxls': 'ئەڭ يۇقىرى لوت',
  'markets.commission': 'كومىسسىيە',
  'markets.sls': 'ئۇزۇن/قىسقا سۋاپ',
  'markets.in': 'مۇھىم ئەسكەرتىشلەر',
  'markets.smv': 'سپرىد يۇقىرى داۋالغۇش ۋە چوڭ خەۋەرلەر مەزگىلىدە ئۆزگىرىشى مۇمكىن',
  'markets.sra': 'سۋاپ نىسبىتى ھەر كۈنى يېڭىلىنىدۇ ۋە بازار ئەھۋالىغا قاراپ ئۆزگىرىشى مۇمكىن',
  'markets.mlm': 'تەسىرى چوڭ خەۋەر مەزگىلىدە ئەڭ يۇقىرى لېۋېرېج تۆۋەنلىتىلىشى مۇمكىن',
  'markets.ata': 'بارلىق ۋاقىت GMT+8 رايونىدا كۆرسىتىلىدۇ',
  'news.title': 'ئەڭ يېڭى بازار خەۋەرلىرى ۋە تەھلىلى',
  'news.subtitle': 'مۇتەخەسسىس كۆز قارىشى ۋە بازار يېڭىلىنىشلىرىدىن خەۋەردار بولۇڭ',
  'news.readMore': 'تېخىمۇ كۆپ ئوقۇڭ',
  'news.category.analysis': 'بازار تەھلىلى',
  'news.category.news': 'جىددىي خەۋەر',
  'news.category.insights': 'مۇتەخەسسىس كۆز قارىشى',
  'news.category.education': 'مائارىپ',
  'news.date': 'ئېلان قىلىنغان',
  'news.author': 'يازغۇچى',
  'home.partners.title': 'ھەمكارلىرىمىز',
  'home.partners.subtitle': 'دۇنيادىكى ئالدىنقى قاتاردىكى سۇيۇقلۇق، پۇل-مۇئامىلە تېخنىكىسى ۋە سودا ئۇل ئەسلىھە تەمىنلىگۈچىلىرى بىلەن ھەمكارلىشىمىز.',
  'testimonials.title': 'دۇنيادىكى مەبلەغ سالغۇچىلارنىڭ ئىشەنچىسى',
  'testimonials.client1.location': 'فىرانكفورت، گېرمانىيە',
  'testimonials.client1.text': 'ئاشكارا باھا ۋە ئىشەنچلىك ئىجراغا ئىگە مۇنەۋۋەر سۇپا. بىخەتەرلىك ئىقتىدارلىرى ماڭا تولۇق ئىشەنچ بېرىدۇ.',
  'testimonials.client2.location': 'پارىژ، فىرانسىيە',
  'testimonials.client2.text': 'كەسپىي مۇلازىمەت ۋە رىقابەتچان سپرىد. كۆپ تىللىق قوللاش ئەترىتى ناھايىتى ياردەمچان.',
  'testimonials.client3.location': 'مىلان، ئىتالىيە',
  'testimonials.client3.text': 'تېز ئىجرا ۋە مۇنەۋۋەر بازار تەھلىل قوراللىرى. قىممەتلىك مېتال سودىسىغا ئەستايىدىل مۇئامىلە قىلىدىغانلارغا تەۋسىيە قىلىمەن.',
  'footer.company': 'شىركەت',
  'footer.trading': 'سودا',
  'footer.support': 'قوللاش',
  'footer.legal': 'قانۇنىي',
  'footer.about': 'بىز ھەققىدە',
  'footer.careers': 'خىزمەت پۇرسىتى',
  'footer.news': 'خەۋەرلەر',
  'footer.platforms': 'سودا سۇپىلىرى',
  'footer.education': 'مائارىپ',
  'footer.analysis': 'بازار تەھلىلى',
  'footer.help': 'ياردەم مەركىزى',
  'footer.contact': 'بىز بىلەن ئالاقىلىشىڭ',
  'footer.faq': 'كۆپ سورالغان سوئاللار',
  'footer.terms': 'ئىشلەتكۈچى كېلىشىمى',
  'footer.privacy': 'شەخسىي مەخپىيەتلىك سىياسىتى',
  'footer.risk': 'خەۋپنى ئاشكارىلاش',
  'footer.copyright': '© 2024 GOLD Label Global Limited. بارلىق ھوقۇق ساقلانغان.',
  'footer.license': 'شياڭگاڭدا قۇرۇلغان شىركەت',
  'footer.riskwarning': 'خەۋپ ئاگاھلاندۇرۇشى',
  'footer.disclaimer': 'كاپالەت پۇلى سودىسى لېۋېرېجلىق پۇل-مۇئامىلە مەھسۇلاتى بولۇپ، زىيىنىڭىز ئامانەت پۇلىڭىزدىن ئېشىپ كېتىشى مۇمكىن. سىز ھېچقانداق ئاساسىي مۈلۈككە ئەمەلىي ئىگە بولمايسىز ياكى ئۇنى ساقلىمايسىز. سودا قىلىشتىن بۇرۇن خەۋپنى ئاشكارىلاش باياناتىمىزنى ئەستايىدىل ئوقۇڭ. خەۋپلەرنى تولۇق چۈشەنگەنلىكىڭىزگە كاپالەتلىك قىلىپ، خەۋپىڭىزنى ئېھتىياتچانلىق بىلەن باشقۇرۇڭ. بۇ تور بەتتىكى ئۇچۇر ياكى مەزمۇنغا ئاساسەن شەخسلەر قىلغان ياكى قىلمىغان ھەرىكەتلەرگە بىز مەسئۇل بولمايمىز.',
  'footer.jurisdiction': 'باشقۇرۇش تەۋەلىكى ئۇقتۇرۇشى',
  'footer.jurisdictionDisclaimer': 'مۇلازىمەت شياڭگاڭ ۋە ئامېرىكىدىن باشقا جايلاردىكى شەرتكە توشىدىغان خېرىدارلارغا، خېرىدار تۇرۇشلۇق جاينىڭ قانۇنى بويىچە مۇلازىمەت قانۇنلۇق بولغان ئەھۋالدا تەمىنلىنىدۇ. شياڭگاڭ ياكى ئامېرىكا ئاھالىلىرىگە، ياكى بۇ خىل مۇلازىمەت قانۇنسىز ياكى چەكلەنگەن ھەر قانداق جايدىكى شەخسكە تەمىنلەنمەيدۇ. بۇ تور بېكىتى چەكلەنگەن جايدىكى شەخسكە قارىتىلمىغان بولۇپ، تەكلىپ، دەۋەت ياكى تەۋسىيە ھېسابلانمايدۇ.',
  'footer.relatedEntity': 'باشقا مۇناسىۋەتلىك ئورۇن',
  'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited سانت لۇسىيەدە 2026-يىلى 9-ئاينىڭ 4-كۈنى قۇرۇلغان خەلقئارالىق سودا شىركىتى بولۇپ، تىزىملاش نومۇرى 2026-00680. تىزىملاتقان ئىشخانا: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. تىزىملاتقان ئىشخانا پەقەت قانۇنىي ۋە نازارەت تەلىپىگە ئەمەل قىلىش ئۈچۈن ساقلىنىدۇ. ئۇ شىركەتنىڭ ئەمەلىي تىجارەت ئورنى ئەمەس، سودا مەشغۇلاتى، خېرىدار زىيارىتى ياكى خەت-چەك ئۈچۈن ئىشلىتىلمەيدۇ.',
  'footer.regNo': 'شىركەت تىزىملاش نومۇرى',
  'common.language': 'تىل',
  'common.loading': 'يۈكلىنىۋاتىدۇ…',
  'common.error': 'خاتالىق',
  'common.success': 'مۇۋەپپەقىيەتلىك',
  'common.close': 'تاقاش',
  'common.save': 'ساقلاش',
  'common.cancel': 'بىكار قىلىش',
  'common.continue': 'داۋاملاشتۇرۇش',
  'common.back': 'قايتىش',
  'common.next': 'كېيىنكى',
  'common.previous': 'ئالدىنقى',
  'common.submit': 'يوللاش',
  'common.reset': 'قايتا تەڭشەش',
  'about.yearsOfExp': 'يىللىق تەجرىبە',
  'about.yearsOfExp.desc': 'قىممەتلىك مېتال سودىسىدا نەچچە ئون يىللىق تەجرىبە',
  'about.dailyTrade': 'كۈندىلىك سودا مىقدارى',
  'about.dailyTrade.desc': 'كۈنىگە 80 مىليارد شياڭگاڭ دوللىرىلىق ئالتۇن-كۈمۈش سودىسى',
  'about.satClients': 'رازى بولغان خېرىدارلار',
  'about.satClients.desc': 'دۇنيادىكى نۇرغۇن خېرىدار ۋە ئورگانلارغا مۇلازىمەت قىلىمىز',
  'about.exeSpeed': 'ئىجرا سۈرئىتى',
  'about.exeSpeed.desc': 'چاقماق تېزلىكىدىكى سودا ئىجرا تېخنىكىسى',
  'about.ourAch': 'مۇۋەپپەقىيەتلىرىمىز',
  'about.ourAch.desc': 'كەسىپتە ئالدىنقى قاتاردىكى نەتىجە بىلەن قىممەتلىك مېتال سودىسىدا ئېتىراپ قىلىنغان مۇنەۋۋەرلىك',
  'about.companyProfile': 'شىركەت تونۇشتۇرۇشى',
  'about.about1': 'Gold Label Global ھەققىدە',
  'about.about2': 'Gold Label Global Limited شياڭگاڭ ھۆكۈمىتى تەستىقلىغان تىزىمغا ئېلىنغان چەكلىك شىركەت بولۇپ، شياڭگاڭ ئالتۇن سودىسى ئورنىنىڭ ئەزاسى. شياڭگاڭ كۈنىگە 80 مىليارد شياڭگاڭ دوللىرىلىق ئالتۇن-كۈمۈش سودىسىنى بىر تەرەپ قىلىدۇ، تەجرىبىسى دۇنيا بويىچە ئالدىنقى قاتاردا.',
  'about.about3': 'Gold Label Global نىڭ باشقۇرۇش ئەترىتى ئالتۇن-كۈمۈش سودىسىدا 20 يىلدىن ئارتۇق مەخسۇس تەجرىبىگە ئىگە. بىز نۇرغۇن خېرىدار ۋە ئورگانلارغا مۇلازىمەت قىلىپ، نەچچە ئون مىلياردلىق سودا بىر تەرەپ قىلدۇق ۋە خېرىدارلار بىلەن كەسپىي زاتلارنىڭ يۇقىرى باھاسىغا ئېرىشتۇق.',
  'about.about4': 'بىز خېرىدارلارغا تېز، مۇقىم ۋە ئەلا سودا مۇھىتى تەمىنلەشكە بەل باغلىدۇق. خەلقئارالىق سودا سىستېمىسى ۋە ئالدىنقى قاتاردىكى تېخنىكا ئەترىتى ئارقىلىق تېخىمۇ كۈچلۈك، مۇكەممەل پروگراممىلارنى تەرەققىي قىلدۇرىمىز.',
  'about.about5': 'Gold Label Global سىز بىلەن بىرلىكتە پايدا يارىتىپ، گۈللىنىشنى ئورتاقلىشىشنى داۋاملاشتۇرىدۇ.',
  'about.about6': 'قىممەتلىك مېتال سودىسىدىكى مۇساپىمىز ۋە دۇنيا پۇل-مۇئامىلە بازىرىدىكى مۇنەۋۋەرلىككە بولغان ۋەدىمىزنى بىلىۋېلىڭ.',
  'about.about7': 'شياڭگاڭ ھۆكۈمىتى تەستىقلىغان چەكلىك شىركەت ۋە شياڭگاڭ ئالتۇن سودىسى ئورنىنىڭ ئەزاسى بولۇش سۈپىتىمىز بىلەن، كۈنىگە 80 مىليارد شياڭگاڭ دوللىرىلىق ئالتۇن-كۈمۈش سودىسىنى بىر تەرەپ قىلىمىز.',
  'about.proTeam': 'كەسپىي ئەترەت',
  'about.proTeam.desc': 'باشقۇرۇش ئەترىتىمىز ئالتۇن-كۈمۈش سودىسىدا 20 يىلدىن ئارتۇق تەجرىبىگە ئىگە بولۇپ، نۇرغۇن خېرىدار ۋە ئورگانلارغا مۇلازىمەت قىلغان.',
  'about.proService': 'كەسپىي مۇلازىمەت',
  'about.proService.desc': 'كەسپىي خېرىدارلار ئەترىتى 24 سائەت توردا ۋە يانفون ئارقىلىق مەسلىھەت بېرىپ، مەسىلىڭىزگە ماس ھەل قىلىش چارىسى بىلەن تەمىنلەيدۇ.',
  'about.sec': 'بىخەتەرلىك بىرىنچى',
  'about.sec.desc': 'سودا قارشى تەرەپ خەۋپى يوق، سودا بىۋاسىتە بازارغا كىرىدۇ؛ ئاشكارا، بىخەتەر ۋە ئىشەنچلىك.',
  'about.strict': 'قاتتىق نازارەت',
  'about.strict.desc': 'Gold Label Global شياڭگاڭ ھۆكۈمىتى نازارەت قىلىدىغان سودا ئورنى ۋە شياڭگاڭ سودا جەمئىيىتىنىڭ ئەزاسى.',
  'about.fastDes': 'تېز مەبلەغ سېلىش',
  'about.fastDes.desc': '24 سائەتلىك مۇلازىمەت، دەرھال مەبلەغ سېلىش ۋە تېز ھېسابات ئېچىش.',
  'about.productSafe': 'مەھسۇلات بىخەتەرلىكى',
  'about.productSafe.desc': 'دۇنيادىكى ئاساسلىق قىممەتلىك مېتال مەھسۇلاتلىرىنى قاپلايدۇ، بىخەتەر ۋە ئىشەنچلىك.',
  'about.whyGLB': 'نېمە ئۈچۈن Gold Label Global نى تاللايسىز',
  'about.whyGLB.desc': 'بىزنى قىممەتلىك مېتال سودىسىدىكى ئالدىنقى تاللاش قىلىدىغان ئەۋزەللىكلەرنى بىلىۋېلىڭ',
  'about.readyToStart': 'سودىنى باشلاشقا تەييارمۇ؟',
  'about.join': 'قىممەتلىك مېتال سودىسىدا GOLD Label Global غا ئىشىنىدىغان مىڭلىغان رازى خېرىدارلارغا قوشۇلۇڭ.',
  'about.openTradingAcc': 'سودا ھېساباتى ئېچىڭ',
  'about.contactTeam': 'ئەترىتىمىز بىلەن ئالاقىلىشىڭ',
  'about.co': 'ھەمكارلىق',
  'about.co.desc': 'خېرىدار ۋە مەنپەئەتدارلار بىلەن ئۆزئارا پايدىلىق ھەمكارلىق قۇرۇش',
  'about.safety': 'بىخەتەرلىك',
  'about.safety.desc': 'بارلىق سودا پائالىيەتلىرىگە ئەڭ يۇقىرى دەرىجىدىكى بىخەتەرلىك كاپالىتى',
  'about.integrity': 'سەمىمىيلىك',
  'about.integrity.desc': 'سەمىمىيلىك ۋە ئاشكارىلىقنىڭ ئەڭ يۇقىرى ئۆلچىمىنى ساقلاش',
  'about.professional': 'كەسپىيلىك',
  'about.professional.desc': 'تەڭداشسىز كەسپىيلىك بىلەن مۇتەخەسسىس مۇلازىمىتى تەمىنلەش',
  'about.fast': 'تېز',
  'about.fast.desc': 'تېز ئىجرا ۋە چاققان خېرىدار مۇلازىمىتى',
  'about.coreValue': 'يادرولۇق قىممەتلىرىمىز',
  'about.coreValue.desc': 'قىممەتلىك مېتال سودىسىدىكى مۇنەۋۋەرلىك ۋەدىمىزنى يېتەكلەيدىغان پرىنسىپلار',
  'contact.sendUsMsg': 'بىزگە ئۇچۇر ئەۋەتىڭ',
  'contact.fillOut': 'تۆۋەندىكى جەدۋەلنى تولدۇرۇڭ، ئەترىتىمىز 24 سائەت ئىچىدە سىز بىلەن ئالاقىلىشىدۇ.',
  'contact.inqType': 'سۈرۈشتۈرۈش تۈرى',
  'contact.genInq': 'ئادەتتىكى سۈرۈشتۈرۈش',
  'contact.accSup': 'ھېسابات قوللىشى',
  'contact.traSup': 'سودا قوللىشى',
  'contact.techSup': 'تېخنىكىلىق قوللاش',
  'contact.partner': 'ھەمكارلىق',
  'contact.fullname': 'تولۇق ئىسمى *',
  'contact.email': 'ئېلخەت ئادرېسى *',
  'contact.phone': 'تېلېفون نومۇرى',
  'contact.subject': 'تېما *',
  'contact.msg': 'ئۇچۇر *',
  'contact.sendMsg': 'ئۇچۇر ئەۋەتىڭ',
  'contact.whyUs': 'نېمە ئۈچۈن بىزنى تاللايسىز؟',
  'contact.regSec': 'نازارەت قىلىنىدىغان ۋە بىخەتەر',
  'contact.licAndReg': 'مەبلىغىڭىزنى قوغدايدىغان ئىلغار بىخەتەرلىك تەدبىرلىرىگە ئىگە ئىجازەتلىك ۋە نازارەت قىلىنىدىغان سودا مۇھىتى.',
  'contact.expSup': 'مۇتەخەسسىس قوللىشى',
  'contact.proService': 'كەسپىي سودا مۇتەخەسسىسلىرى 24/7 سودا ئېھتىياجىڭىز ۋە سوئاللىرىڭىزغا ياردەم بېرىدۇ.',
  'contact.fastExe': 'تېز ئىجرا',
  'contact.lightFast': 'ئەڭ ياخشى سودا نەتىجىسى ئۈچۈن تۆۋەن سىيرىلىش بىلەن چاقماق تېزلىكىدىكى بۇيرۇق ئىجراسى.',
  'contact.glbNet': 'دۇنيا بازارلىرى',
  'contact.asscessToint': 'رىقابەتچان سپرىد ۋە چوڭقۇر سۇيۇقلۇق بىلەن خەلقئارالىق قىممەتلىك مېتال بازارلىرىغا كىرىڭ.',
  'contact.followUs': 'ئىجتىمائىي تاراتقۇدا بىزگە ئەگىشىڭ:',
  'contact.contactOutPro': 'سودا قوللىشى، ھېسابات ياردىمى ياكى ئادەتتىكى سۈرۈشتۈرۈش ئۈچۈن كەسپىي ئەترىتىمىز بىلەن ئالاقىلىشىڭ:',
  'contact.officeAddress': 'ئىشخانا ئادرېسى',
  'contact.bussHour': 'خىزمەت ۋاقتى: دۈشەنبە-جۈمە 9:00–18:00 (GMT+8)',
  'contact.phoneSupp': 'تېلېفون قوللىشى',
  'contact.mainOffice': 'باش ئىشخانا',
  'contact.availableServices': 'بار بولغان مۇلازىمەتلەر:',
  'contact.accOpenSup': 'ھېسابات ئېچىش قوللىشى',
  'contact.tradSup': 'سودا سۇپىسى ياردىمى',
  'contact.genSup': 'ئادەتتىكى قوللاش',
  'contact.emailSup': 'ئېلخەت قوللىشى',
  'contact.responseTime': 'جاۋاب قايتۇرۇش ۋاقتى:',
  'contact.genInq24': 'ئادەتتىكى سۈرۈشتۈرۈش: 24 سائەت ئىچىدە',
  'contact.techSup24': 'تېخنىكىلىق قوللاش: 4 سائەت ئىچىدە',
  'contact.accIss24': 'ھېسابات مەسىلىسى: 2 سائەت ئىچىدە',
  'contact.needImSup': 'دەرھال ياردەم كېرەكمۇ؟',
  'contact.needImSup.desc': 'سودا مۇتەخەسسىسلىرىمىز جىددىي سودا ئىشلىرى ۋە ھېسابات قوللىشى ئۈچۈن 24/7 مۇلازىمەت قىلىدۇ.',
  'contact.callNow': 'ھازىر تېلېفون قىلىڭ',
  'contact.sendEmail': 'ئېلخەت ئەۋەتىڭ',
  'contact.contactUs': 'بىز بىلەن ئالاقىلىشىڭ',
  'contact.getInTouch': 'كەسپىي سودا ئەترىتىمىز بىلەن ئالاقىلىشىڭ. قىممەتلىك مېتال سودىسىدا مۇۋەپپەقىيەت قازىنىشىڭىزغا ياردەم بېرىمىز.',
  'contact.247Sup': '24/7 قوللاش',
  'contact.247Sup.desc': 'بارلىق سودا ئېھتىياجىڭىز ئۈچۈن كېچە-كۈندۈز خېرىدار مۇلازىمىتى',
  'contact.dirLine': 'بىۋاسىتە لىنىيە',
  'contact.dirLine.desc': 'سودا مۇتەخەسسىسلىرىمىز بىلەن بىۋاسىتە سۆزلىشىڭ',
  'contact.hkOffice': 'شياڭگاڭ ئىشخانىسى',
  'contact.hkOffice.desc': 'شياڭگاڭ پۇل-مۇئامىلە رايونىنىڭ مەركىزىگە جايلاشقان',
  'platform.wco': 'نېمە ئۈچۈن MT5 سۇپىمىزنى تاللايسىز؟',
  'platform.etd': 'كەسپىي سودىگەرلەر ئۈچۈن لايىھەلەنگەن ئالىي دەرىجىلىك سۇپىمىزنىڭ پەرقىنى ھېس قىلىڭ',
  'platform.rts': 'سودىنى باشلاشقا تەييارمۇ؟',
  'platform.jto': 'قىممەتلىك مېتال سودىسىدا سۇپىمىزغا ئىشىنىدىغان مىڭلىغان سودىگەرلەرگە قوشۇلۇڭ',
  'platform.ola': 'ھەقىقىي ھېسابات ئېچىڭ',
  'platform.tda': 'سىناق ھېساباتىنى ئىشلىتىڭ',
  'platform.dmt': 'MT5 سۇپىسىنى چۈشۈرۈڭ',
  'platform.ayt': 'كۆپ سۇپىلىق MT5 ئەپلىرىمىز ئارقىلىق ھەر قانداق ئۈسكۈنىدىن سودا ھېساباتىڭىزغا كىرىڭ',
  'platform.free': 'ھەقسىز',
  'platform.dn': 'ھازىر چۈشۈرۈڭ',
  'platform.sr': 'سىستېما تەلىپى',
  'platform.nh': 'باشلاشتا ياردەم كېرەكمۇ؟',
  'platform.os': 'قوللاش ئەترىتىمىز سەپلەش ۋە سودا باشلاشقا ياردەم بېرىشكە تەييار',
  'platform.ug': 'ئىشلەتكۈچى قوللانمىسى',
  'platform.cs': 'قوللاش بىلەن ئالاقىلىشىڭ',
  'platform.si': 'مۇقىم تور ئۇلىنىشى زۆرۈر',
  'platform.ptf': 'كۈچلۈك سودا ئىقتىدارلىرى',
  'platform.epg': 'يېڭى باشلىغۇچىلار ۋە مۇتەخەسسىسلەر ئۈچۈن لايىھەلەنگەن كەسپىي دەرىجىلىك سودا قوراللىرى',
  'platform.ac': 'ئىلغار گرافىك',
  'platform.pct': '80 دىن ئارتۇق تېخنىكىلىق كۆرسەتكۈچ ۋە كۆپ ۋاقىت چاستوتىسى بىلەن ئەتراپلىق بازار تەھلىلى قىلىدىغان كەسپىي گرافىك قوراللىرى.',
  'platform.lfe': 'چاقماق تېزلىكىدىكى ئىجرا',
  'platform.ull': 'ئەڭ ياخشى كىرىش-چىقىش ئۈچۈن 0.01 سېكۇنتقىچە تېزلىكتە ئىنتايىن تۆۋەن كېچىكىشلىك سودا.',
  'platform.ea': 'Expert Advisor (EA)',
  'platform.atc': 'خاس Expert Advisor ۋە ئالگورىزىملىق ئىستراتېگىيە بىلەن ئاپتوماتىك سودا.',
  'platform.rm': 'خەۋپ باشقۇرۇش',
  'platform.crm': 'زىيان توختىتىش، پايدا ئېلىش ۋە پوزىتسىيە مىقدارىنى كونترول قىلىشنى ئۆز ئىچىگە ئالغان ئەتراپلىق خەۋپ باشقۇرۇش قوراللىرى.',
  'platform.mpa': 'كۆپ سۇپىلىق زىيارەت',
  'platform.tsa': 'ماس قەدەملىك ھېسابات بىلەن كومپيۇتېر، تور ۋە يانفوندا راۋان سودا قىلىڭ.',
  'platform.gm': 'دۇنيا بازارلىرى',
  'platform.ati': 'قىممەتلىك مېتال، تاشقى پېرېۋوت، كۆرسەتكۈچ ۋە تاۋارلارنى ئۆز ئىچىگە ئالغان خەلقئارالىق بازارلارغا كىرىڭ.',
  'platform.etw': 'دۇنيادىكى ئەڭ ئىلغار سودا سۇپىسىنى ئىشلىتىڭ. ئورگان دەرىجىلىك تېخنىكا ۋە چاقماق تېزلىكىدىكى ئىجرا بىلەن قىممەتلىك مېتال، تاشقى پېرېۋوت ۋە CFD سودىسى قىلىڭ.',
  'platform.download': 'چۈشۈرۈش ',
  'platform.wd': 'كۆرسەتمىنى كۆرۈڭ',
  'platform.es': 'ئىجرا سۈرئىتى',
  'platform.th': 'سودا ۋاقتى',
  'platform.in': 'قوراللار',
  'platform.lt': 'ھەقىقىي سودا',
  'platform.ptt': 'كەسپىي سودا قوراللىرى',
  'platform.aig': 'كەسپىي سودىگەر ۋە ئەستايىدىل مەبلەغ سالغۇچىلار ئۈچۈن ئورگان دەرىجىلىك قوراللار',
  'platform.rtd': 'ھەقىقىي ۋاقىتتىكى سانلىق مەلۇمات',
  'platform.lmd': 'نەق بازار سانلىق مەلۇماتى ۋە دەرھال باھا يېڭىلىنىشى',
  'platform.pa': 'باھا ئاگاھلاندۇرۇشى',
  'platform.caf': 'باھا ئۆزگىرىشى ۋە بازار ۋەقەلىرى ئۈچۈن خاس ئاگاھلاندۇرۇش',
  'platform.this': 'سودا تارىخى',
  'platform.cth': 'ئەتراپلىق سودا تارىخى ۋە نەتىجە تەھلىلى',
  'platform.ec': 'ئىقتىسادىي كالېندار',
  'platform.suw': 'مۇھىم ئىقتىسادىي ۋەقەلەردىن خەۋەردار بولۇڭ',
  'platform.mw': 'بازار كۆزىتىش',
  'platform.rtp': 'بارلىق قوراللارنىڭ ھەقىقىي ۋاقىتتىكى باھاسى ۋە بازار چوڭقۇرلۇقى',
  'platform.om': 'بۇيرۇق باشقۇرۇش',
  'platform.aot': 'بازار، چەكلىك، توختىتىش ۋە ئەگىشىپ توختىتىش قاتارلىق ئىلغار بۇيرۇق تۈرلىرى',
  'platform.ta': 'تېخنىكىلىق تەھلىل',
  'platform.cta': 'خاس كۆرسەتكۈچ ۋە سىزىش قوراللىرىغا ئىگە ئەتراپلىق تېخنىكىلىق تەھلىل قوراللىرى',
  'platform.ufe': 'ئىنتايىن تېز ئىجرا',
  'platform.rtc': 'سودا ۋە تېخنىكا مۇتەخەسسىسلىرىمىزنىڭ كېچە-كۈندۈز خېرىدار قوللىشى',
  'platform.247a': '24/7 بار',
  'platform.csp': 'رىقابەتچان سپرىد',
  'platform.iia': 'كەسىپتە ئالدىنقى سپرىد، ئاشكارا باھا، يوشۇرۇن ھەق ۋە كومىسسىيە يوق',
  'platform.01pip': '0.1 پىپتىن باشلىنىدۇ',
  'platform.ffd': 'Windows 10/11 ئۈچۈن تولۇق ئىقتىدارلىق كومپيۇتېر ئەپى',
  'platform.nma': 'تولۇق ئىقتىدارلىق ئەسلى macOS ئەپى',
  'platform.mta': 'Android ئۈسكۈنىلىرى ئۈچۈن يانفون سودا ئەپى',
  'platform.iai': 'iPhone ۋە iPad سودا ئەپى',
  'faq.tagline': 'سىزگە قانداق ياردەم بېرەلەيمىز؟',
  'faq.title': 'سىزگە قانداق ياردەم بېرەلەيمىز؟',
  'faq.subtitle': 'سوئاللىرىڭىزغا تېز جاۋاب تېپىش ئۈچۈن ئەتراپلىق كۆپ سورالغان سوئاللارنى كۆرۈڭ',
  'faq.categories': 'تۈرلەر',
  'faq.cantFind': 'ئىزدەۋاتقىنىڭىزنى تاپالمىدىڭىزمۇ؟',
  'faq.supportText': 'قوللاش ئەترىتىمىز بۇ بۆلەكتە يوق سوئاللىرىڭىزغا ياردەم بېرىدۇ.',
  'faq.contactSupport': 'قوللاش ئەترىتى بىلەن ئالاقىلىشىڭ',
  'faq.general': 'ئادەتتىكى',
  'faq.account': 'ھېسابات',
  'faq.trading': 'سودا',
  'faq.platform': 'سۇپا',
  'faq.deposits': 'مەبلەغ سېلىش ۋە ئېلىش',
  'faq.security': 'بىخەتەرلىك',
  'faq.general.q1': 'GOLD LABEL GLOBAL LIMITED دېگەن نېمە؟',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED شياڭگاڭدىكى نازارەت قىلىنىدىغان قىممەتلىك مېتال سودا شىركىتى بولۇپ، MT5 سۇپىسى ئارقىلىق ئالتۇن، كۈمۈش ۋە باشقا قىممەتلىك مېتاللارغا كەسپىي سودا مۇلازىمىتى تەمىنلەيدۇ.',
  'faq.general.q2': 'قايسى سودا قوراللىرىنى تەمىنلەيسىلەر؟',
  'faq.general.a2': 'نەق ئالتۇن (XAU/USD)، نەق كۈمۈش (XAG/USD)، پىلاتىنا، پاللادىي ۋە ھەر خىل قىممەتلىك مېتال قەرەللىك توختاملىرىنى ئۆز ئىچىگە ئالغان كەڭ دائىرىلىك مەھسۇلاتلارنى تەمىنلەيمىز.',
  'faq.general.q3': 'سودا ۋاقتىڭلار قاچان؟',
  'faq.general.a3': 'قىممەتلىك مېتال بازارلىرىمىز خەلقئارا بازار ۋاقتى بويىچە يەكشەنبە EST 17:00 دىن جۈمە EST 16:00 گىچە، كۈنىگە 24 سائەت، ھەپتىدە 5 كۈن ئوچۇق.',
  'faq.general.q4': 'شىركىتىڭلاردا مەبلىغىم بىخەتەرمۇ؟',
  'faq.general.a4': 'شۇنداق، بىز تولۇق نازارەت قىلىنىمىز ۋە ئىجازەت ئالغان. خېرىدار مەبلىغى ئايرىم ساقلىنىپ، بىخەتەر بانكا ھېساباتىدا تۇرىدۇ. قوشۇمچە قوغداش ئۈچۈن ئەتراپلىق سۇغۇرتامۇ بار.',
  'faq.account.q1': 'سودا ھېساباتىنى قانداق ئاچىمەن؟',
  'faq.account.a1': 'توردا ئىلتىماس جەدۋىلىنى تولدۇرۇپ، كېرەكلىك كىملىك ھۆججەتلىرىنى تاپشۇرۇپ ۋە دەسلەپكى ئامانەتنى سېلىپ ھېسابات ئاچالايسىز. ئادەتتە 1–2 خىزمەت كۈنى كېتىدۇ.',
  'faq.account.q2': 'ئەڭ تۆۋەن ئامانەت قانچىلىك؟',
  'faq.account.a2': 'ئادەتتىكى ھېساباتنىڭ ئەڭ تۆۋەن دەسلەپكى ئامانىتى 1,000 ئامېرىكا دوللىرى. يۇقىرى ئامانەت ۋە قوشۇمچە ئەۋزەللىككە ئىگە ئالىي ھېساباتلارمۇ بار.',
  'faq.account.q3': 'بىر نەچچە سودا ھېساباتى ئاچسام بولامدۇ؟',
  'faq.account.a3': 'شۇنداق، ئوخشىمىغان ئاساسىي پۇل ياكى ھېسابات تۈرىدە بىر نەچچە ھېسابات ئېچىپ، ھەر خىل سودا ۋە خەۋپ باشقۇرۇش ئېھتىياجىڭىزغا ماسلاشتۇرالايسىز.',
  'faq.account.q4': 'ھېساباتىمنى قانداق دەلىللەيمەن؟',
  'faq.account.a4': 'ھېسابات دەلىللەش ئۈچۈن ھۆكۈمەت بەرگەن كىملىك (پاسپورت ياكى شوپۇرلۇق كىنىشكىسى) ۋە يېقىنقى 3 ئاي ئىچىدىكى ئادرېس ئىسپاتى (توك-سۇ تالونى ياكى بانكا باياناتى) كېرەك.',
  'faq.trading.q1': 'ئەڭ تۆۋەن سودا مىقدارى قانچىلىك؟',
  'faq.trading.a1': 'كۆپىنچە قىممەتلىك مېتال قورالىنىڭ ئەڭ تۆۋەن سودا مىقدارى 0.01 لوت. بۇ بارلىق سەۋىيەدىكى سودىگەرلەرگە جانلىق پوزىتسىيە مىقدارى ۋە خەۋپ باشقۇرۇش ئىمكانىيىتى بېرىدۇ.',
  'faq.trading.q2': 'قانچىلىك لېۋېرېج تەمىنلەيسىلەر؟',
  'faq.trading.a2': 'قىممەتلىك مېتال سودىسىغا 1:100 گىچە رىقابەتچان لېۋېرېج تەمىنلەيمىز؛ بۇ مەسئۇلىيەتچان خەۋپ باشقۇرۇش بىلەن سودا ئىمكانىيىتىڭىزنى ئاشۇرىدۇ.',
  'faq.trading.q3': 'سودا ھەققى بارمۇ؟',
  'faq.trading.a3': 'كومىسسىيەسىز سپرىد ئاساسىدىكى مودېلنى قوللىنىمىز. سپرىدىمىز رىقابەتچان ۋە ئاشكارا، يوشۇرۇن چىقىم ياكى كۈتۈلمىگەن ھەق يوق.',
  'faq.trading.q4': 'ئاپتوماتىك سودا ئىستراتېگىيەسى ئىشلىتەمدىم؟',
  'faq.trading.a4': 'شۇنداق، MT5 سۇپىمىز Expert Advisor (EA) ۋە ئاپتوماتىك سودا ئىستراتېگىيەلىرىنى تولۇق قوللايدۇ. خاس ئالگورىزىم تۈزسىڭىز ياكى مەۋجۇت سودا روبوتىنى ئىشلەتسىڭىز بولىدۇ.',
  'faq.platform.q1': 'قايسى سودا سۇپىلىرىنى قوللايسىلەر؟',
  'faq.platform.a1': 'ئاساسلىقى كەسىپتە ئالدىنقى MetaTrader 5 (MT5) نى ئىشلىتىمىز. MT5 كومپيۇتېر (Windows/Mac)، يانفون (iOS/Android) ۋە تور كۆرگۈدە بار.',
  'faq.platform.q2': 'MT5 سۇپىسى ھەقسىزمۇ؟',
  'faq.platform.a2': 'شۇنداق، MT5 نى چۈشۈرۈش ۋە ئىشلىتىش پۈتۈنلەي ھەقسىز. بارلىق سۇپا ئىقتىدارى، گرافىك، كۆرسەتكۈچ ۋە سودا قورالىغا قوشۇمچە ھەقسىز كىرەلەيسىز.',
  'faq.platform.q3': 'يانفوندا سودا قىلالامدىم؟',
  'faq.platform.a3': 'ئەلۋەتتە! iOS ۋە Android ئۈچۈن MT5 ئەپلىرىمىز تولۇق سودا ئىقتىدارى، ھەقىقىي ۋاقىتتىكى گرافىك، بازار خەۋەرلىرى ۋە ھېسابات باشقۇرۇشنى تەمىنلەيدۇ.',
  'faq.platform.q4': 'سىناق ھېساباتى تەمىنلەيسىلەر؟',
  'faq.platform.a4': 'شۇنداق، ھەقىقىي مەبلەغ سېلىشتىن بۇرۇن سودا مەشىقى ۋە سۇپا بىلەن تونۇشۇش ئۈچۈن مەۋھۇم مەبلەغلىك ھەقسىز سىناق ھېساباتى تەمىنلەيمىز.',
  'faq.deposits.q1': 'قايسى ئامانەت ئۇسۇللىرىنى قوبۇل قىلىسىلەر؟',
  'faq.deposits.a1': 'بانكا يۆتكەش، ئىناۋەت/قەرز كارتىسى (Visa، MasterCard) ۋە ھەر خىل ئېلېكترونلۇق پۇل تۆلەش ئۇسۇللىرىنى قوبۇل قىلىمىز. بارلىق ئامانەت بىخەتەر ۋە ئۈنۈملۈك بىر تەرەپ قىلىنىدۇ.',
  'faq.deposits.q2': 'ئامانەتنى بىر تەرەپ قىلىشقا قانچىلىك ۋاقىت كېتىدۇ؟',
  'faq.deposits.a2': 'ئىناۋەت كارتىسى ئادەتتە دەرھال، بانكا يۆتكەش 1–3 خىزمەت كۈنى، ئېلېكترونلۇق پۇل تۆلەش بىر نەچچە سائەت ئىچىدە بىر تەرەپ قىلىنىدۇ.',
  'faq.deposits.q3': 'ئامانەت ھەققى بارمۇ؟',
  'faq.deposits.a3': 'كۆپىنچە ئامانەت ئۇسۇلىغا ھەق ئالمايمىز. ئەمما بانكا ياكى پۇل تۆلەش تەمىنلىگۈچىڭىز ئۆز بىر تەرەپ قىلىش ھەققىنى ئېلىشى مۇمكىن.',
  'faq.deposits.q4': 'مەبلىغىمنى قانداق ئېلىۋالىمەن؟',
  'faq.deposits.a4': 'خېرىدار پورتىدىن مەبلەغ ئېلىشنى ئىلتىماس قىلالايسىز. مەبلەغ ئادەتتە ئامانەت سېلىشتا ئىشلەتكەن ئۇسۇلغا قايتۇرۇلىدۇ، ۋاقىت پۇل تۆلەش ئۇسۇلىغا قاراپ ئوخشىمايدۇ.',
  'faq.security.q1': 'شەخسىي ئۇچۇرۇمنى قانداق قوغدايسىلەر؟',
  'faq.security.a1': 'بارلىق سانلىق مەلۇمات يوللاشنى قوغداش ئۈچۈن بانكا دەرىجىلىك شىفىرلاش (SSL 256-bit) ئىشلىتىمىز. شەخسىي ئۇچۇرىڭىز بىخەتەر ساقلىنىدۇ ۋە رۇخسىتىڭىزسىز ئۈچىنچى تەرەپكە بېرىلمەيدۇ.',
  'faq.security.q2': 'ئىككى ئامىللىق دەلىللەش بارمۇ؟',
  'faq.security.a2': 'شۇنداق، ھېساباتىڭىزدا ئىككى ئامىللىق دەلىللەش (2FA) نى قوزغىتىشنى كۈچلۈك تەۋسىيە قىلىمىز. بۇ رۇخسەتسىز كىرىشتىن قوغدايدىغان قوشۇمچە بىخەتەرلىك قاتلىمى.',
  'faq.security.q3': 'پارولنى ئۇنتۇپ قالسام قانداق قىلىمەن؟',
  'faq.security.a3': 'كىرىش بېتىدىكى «پارولنى ئۇنتۇدىڭىزمۇ؟» ئۇلانمىسى ئارقىلىق پارولنى قايتا تەڭشىيەلەيسىز. يېڭى پارول قۇرۇش ئۈچۈن ئېلخەتتە بىخەتەر ئۇلانما تاپشۇرۇۋالىسىز.',
  'faq.security.q4': 'ئادىل سودا شەرتلىرىگە قانداق كاپالەتلىك قىلىسىلەر؟',
  'faq.security.a4': 'بارلىق خېرىدارلارغا ئادىل ۋە ئەخلاقلىق سودا مۇھىتى يارىتىش ئۈچۈن ھەقىقىي ۋاقىتتىكى بازار سانلىق مەلۇماتى، سودا ئۈستىلى ئارىلىشىشى يوق ئاشكارا باھا ۋە قاتتىق قائىدىگە ئەمەل قىلىشنى تەمىنلەيمىز.',
  'hero.browseFAQ': 'سوئاللارنى كۆرۈڭ',
  'hero.contactSupport': 'قوللاش بىلەن ئالاقىلىشىڭ',
  'contactCTA.phoneTitle': 'تېلېفون قوللىشى',
  'contactCTA.phoneDesc': 'مۇتەخەسسىسلىرىمىز بىلەن بىۋاسىتە سۆزلىشىڭ',
  'contactCTA.callNow': 'ھازىر تېلېفون قىلىڭ',
  'contactCTA.emailTitle': 'ئېلخەت قوللىشى',
  'contactCTA.emailDesc': 'تەپسىلىي يازما جاۋابقا ئېرىشىڭ',
  'contactCTA.sendMsg': 'ئۇچۇر ئەۋەتىڭ',
  'contactCTA.chatTitle': 'نەق سۆھبەت',
  'contactCTA.chatDesc': 'دەرھال ئۇچۇر قوللىشى',
  'contactCTA.available': '24/7 بار',
  'contactCTA.startChat': 'سۆھبەتنى باشلاڭ',
  'contactCTA.title': 'يەنىلا ياردەم كېرەكمۇ؟',
  'contactCTA.subtitle': 'مۇتەخەسسىس قوللاش ئەترىتىمىز سوئال ياكى ئەندىشىڭىزگە ياردەم بېرىش ئۈچۈن 24/7 بار.',
  'markets.specsTitle': 'سودا قائىدىلىرى',
  'markets.specsDisclaimer': '* سودا شەرتلىرى سۇپا تەڭشىكى ۋە بازار سۇيۇقلۇقىغا باغلىق.',
  'markets.spreadTypeFloating': 'لەيلىمە سپرىد',
  'markets.points': 'نۇقتا',
  'markets.variableByMarket': 'بازارغا قاراپ ئۆزگىرىدۇ',
  'markets.table.symbol': 'بەلگە',
  'markets.table.contractUnit': 'توختام بىرلىكى',
  'markets.table.minLot': 'ئەڭ تۆۋەن لوت',
  'markets.table.maxLot': 'ئەڭ يۇقىرى لوت',
  'markets.table.leverage': 'لېۋېرېج',
  'markets.table.spreadType': 'سپرىد تۈرى',
  'markets.table.avgSpread': 'ئوتتۇرىچە سپرىد',
  'markets.table.swapLong': 'ئۇزۇن سۋاپ',
  'markets.table.swapShort': 'قىسقا سۋاپ',
  'markets.contractSections.contractSize.title': 'توختام مىقدارى',
  'markets.contractSections.contractSize.items.xauusd.label': 'ئالتۇن (XAUUSD)',
  'markets.contractSections.contractSize.items.xauusd.desc': 'ئالتۇن سودىسىنىڭ ئۆلچەملىك توختام مىقدارى',
  'markets.contractSections.contractSize.items.xagusd.label': 'كۈمۈش (XAGUSD)',
  'markets.contractSections.contractSize.items.xagusd.desc': 'كۈمۈش سودىسىنىڭ ئۆلچەملىك توختام مىقدارى',
  'markets.contractSections.contractSize.items.gaucnh.desc': 'دېڭىز سىرتى خەلق پۇلىغا مۇناسىۋەتلىك تاشقى پېرېۋوت سودىسىنىڭ ئۆلچەملىك توختام مىقدارى',
  'markets.contractSections.priceMove.title': 'ئەڭ تۆۋەن باھا ئۆزگىرىشى',
  'markets.contractSections.priceMove.items.goldTick.label': 'ئالتۇن تىك مىقدارى',
  'markets.contractSections.priceMove.items.goldTick.desc': 'ئەڭ تۆۋەن باھا ئۆسۈشى',
  'markets.contractSections.priceMove.items.silverTick.label': 'كۈمۈش تىك مىقدارى',
  'markets.contractSections.priceMove.items.silverTick.desc': 'ئەڭ تۆۋەن باھا ئۆسۈشى',
  'markets.contractSections.priceMove.items.fxTick.label': 'تاشقى پېرېۋوت تىك مىقدارى',
  'markets.contractSections.priceMove.items.fxTick.desc': 'پۇل جۈپ باھاسىنىڭ ئەڭ تۆۋەن ئۆسۈشى',
  'markets.contractSections.settlement.title': 'ھېساب راسلاش ئۇسۇلى',
  'markets.contractSections.settlement.items.type.label': 'ھېساب راسلاش تۈرى',
  'markets.contractSections.settlement.items.type.value': 'نەق پۇلدا ھېساب راسلاش',
  'markets.contractSections.settlement.items.type.desc': 'ئەمەلىي تاپشۇرۇش تەلەپ قىلىنمايدۇ',
  'markets.contractSections.settlement.items.currency.label': 'ھېساب راسلاش پۇلى',
  'markets.contractSections.settlement.items.currency.desc': 'مېتال قوراللىرى ئامېرىكا دوللىرىدا ھېسابلىنىدۇ',
  'markets.contractSections.settlement.items.fxQuote.label': 'باھا پۇلى',
  'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH نىڭ باھاسى CNH بويىچە بېرىلىدۇ',
  'markets.contractSections.positionLimits.title': 'پوزىتسىيە چەكلىمىسى',
  'markets.contractSections.positionLimits.items.maxPosition.label': 'ئەڭ يۇقىرى پوزىتسىيە',
  'markets.contractSections.positionLimits.items.maxPosition.desc': 'ھەر ھېساباتتىكى ھەر بىر قورالغا',
  'markets.contractSections.positionLimits.items.orderDistance.label': 'بۇيرۇق ئارىلىقى',
  'markets.contractSections.positionLimits.items.orderDistance.desc': 'بازار باھاسىدىن ئەڭ تۆۋەن ئارىلىق',
  'markets.contractSections.positionLimits.items.execution.label': 'ئىجرا ئۇسۇلى',
  'markets.contractSections.positionLimits.items.execution.value': 'بازار ئىجراسى',
  'markets.contractSections.positionLimits.items.execution.desc': 'بۇيرۇق بازار سۇيۇقلۇق ئەھۋالىغا ئاساسەن ئىجرا قىلىنىدۇ',
  'markets.days.monday': 'دۈشەنبە',
  'markets.days.tuesday': 'سەيشەنبە',
  'markets.days.wednesday': 'چارشەنبە',
  'markets.days.thursday': 'پەيشەنبە',
  'markets.days.friday': 'جۈمە',
  'markets.days.saturday': 'شەنبە',
  'markets.days.sunday': 'يەكشەنبە',
  'markets.hours.closed': 'بازار تاقاق',
  'markets.holidays.newYear.date': '1-يانۋار',
  'markets.holidays.newYear.event': 'يېڭى يىل',
  'markets.holidays.christmas.date': '25-دېكابىر',
  'markets.holidays.christmas.event': 'روژدېستۋو بايرىمى',
  'markets.holidays.independence.date': '4-ئىيۇل',
  'markets.holidays.independence.event': 'مۇستەقىللىق كۈنى (ئامېرىكا)',
  'markets.holidays.thanksgiving.date': '24-نويابىر',
  'markets.holidays.thanksgiving.event': 'مىننەتدارلىق بايرىمى (ئامېرىكا)',
  'news.pageTitle': 'پۇل-مۇئامىلە خەۋەرلىرى',
  'news.pageDesc': 'ئالتۇن، بازار، ئۆسۈم نىسبىتى ۋە مەركىزىي بانكىلار ھەققىدىكى تاللانغان يېڭىلىنىشلار؛ ئەنئەنىۋى خەنزۇچە، ئاددىي خەنزۇچە، ئىنگلىزچە ۋە ئۇيغۇرچە مەزمۇن.',
  'news.searchPlaceholder': 'خەۋەر ئىزدەڭ',
  'news.empty': 'سۈزگۈچكە ماس خەۋەر تېپىلمىدى',
  'news.filter.all': 'ھەممىسى',
  'news.filter.gold': 'ئالتۇن',
  'news.filter.markets': 'بازارلار',
  'news.filter.rates': 'ئۆسۈم نىسبىتى',
  'news.filter.centralBank': 'مەركىزىي بانكا',
  'news.filter.logistics': 'لوگىستىكا',
  'license.hero.badge': 'رەسمىي گۇۋاھنامە',
  'license.hero.title': 'شياڭگاڭ ئالتۇن سودىسى ئورنى ئەزالىق ئىجازەتنامىسى',
  'license.hero.subtitle': 'GOLD Label Global Limited شياڭگاڭ ئالتۇن سودىسى ئورنىنىڭ 10-نومۇرلۇق ئەزاسى بولۇپ، رەسمىي ئېتىراپ قىلىنغان ۋە نازارەت قىلىنىدۇ؛ قىممەتلىك مېتال سودىڭىزغا ئەڭ يۇقىرى كاپالەت بېرىدۇ.',
  'license.hero.badge1': 'رەسمىي ئىجازەتلىك ئەزا',
  'license.hero.badge2': '10-نومۇرلۇق ئەزا',
  'license.hero.badge3': 'شياڭگاڭ ھۆكۈمىتى ئېتىراپ قىلغان',
  'license.details.badge': 'ئىجازەتنامە تەپسىلاتى',
  'license.details.title': 'رەسمىي ئىجازەتنامىمىز',
  'license.details.subtitle': 'شياڭگاڭ ئالتۇن سودىسى ئورنى تەرىپىدىن تولۇق ئىجازەت ئالغان ۋە نازارەت قىلىنىدىغان، ئەڭ يۇقىرى ئۆلچەمدىكى قىممەتلىك مېتال سودا مۇلازىمىتى',
  'license.image.label': 'رەسمىي ئىجازەتنامە ھۆججىتى',
  'license.image.placeholder': 'ئىجازەتنامە گۇۋاھنامىسى',
  'license.image.desc': 'شياڭگاڭ ئالتۇن سودىسى ئورنىنىڭ رەسمىي ئەزالىق ئىجازەتنامىسى',
  'license.image.verified': 'شياڭگاڭ ئالتۇن سودىسى ئورنى تەرىپىدىن دەلىللەنگەن',
  'license.member.label': 'ئەزا نومۇرى',
  'license.member.title': 'شياڭگاڭ ئالتۇن سودىسى ئورنى ئەزاسى',
  'license.info.title': 'ئەزالىقىمىز ھەققىدە',
  'license.info.desc1': 'GOLD Label Global Limited شياڭگاڭ ئالتۇن سودىسى ئورنى (香港黃金交易所) نىڭ رەسمىي ئەزاسى بولۇپ، 10-نومۇرلۇق ئەزا سالاھىيىتىگە ئىگە. بۇ ئورۇن 100 يىلدىن ئارتۇق تارىخقا ئىگە شياڭگاڭدىكى ئەڭ قەدىمىي ۋە ئەڭ چوڭ قىممەتلىك مېتال سودا ئورنى، شۇنداقلا دۇنيادىكى مۇھىم ئالتۇن سودا مەركەزلىرىنىڭ بىرى.',
  'license.info.desc2': 'رەسمىي ئەزا بولۇش سۈپىتىمىز بىلەن، سودا ئورنىنىڭ بارلىق قائىدە ۋە نازارەت تەلىپىگە قاتتىق ئەمەل قىلىپ، ھەر بىر سودىنىڭ ئاشكارا، ئادىل ۋە بىخەتەر مۇھىتتا ئېلىپ بېرىلىشىغا كاپالەتلىك قىلىمىز.',
  'license.info.org.label': 'نازارەت ئورگىنى',
  'license.info.org.value': 'شياڭگاڭ ئالتۇن سودىسى ئورنى (香港黃金交易所)',
  'license.info.member.label': 'ئەزا نومۇرى',
  'license.info.member.value': '10-نومۇرلۇق ئەزا',
  'license.info.jurisdiction.label': 'باشقۇرۇش تەۋەلىكى',
  'license.info.jurisdiction.value': 'شياڭگاڭ ئالاھىدە مەمۇرىي رايونى',
  'license.info.status.label': 'ئىجازەتنامە ھالىتى',
  'license.info.status.value': 'ئاكتىپ ۋە قائىدىگە ئۇيغۇن',
  'license.features.title': 'ئەزالىقىمىز نېمىنى بىلدۈرىدۇ',
  'license.features.official.title': 'رەسمىي ئېتىراپ قىلىنغان',
  'license.features.official.desc': 'شياڭگاڭ ئالتۇن سودىسى ئورنى رەسمىي ئېتىراپ قىلغان، بارلىق نازارەت تەلىپى ۋە كەسىپ ئۆلچىمىگە ماس',
  'license.features.trading.title': 'سودا ھوقۇقى بار',
  'license.features.trading.desc': 'قىممەتلىك مېتال سودا كەسپىنى تولۇق قائىدىگە ئۇيغۇن ئېلىپ بېرىشقا قانۇنىي سالاھىيەتلىك',
  'license.features.regulated.title': 'قاتتىق نازارەت قىلىنىدۇ',
  'license.features.regulated.desc': 'سودا ئورنىنىڭ قاتتىق نازارىتىدە، قەرەللىك قائىدە تەكشۈرۈشى ۋە مۇپەتتىشلىككە قاتنىشىدۇ',
  'license.features.international.title': 'خەلقئارالىق ئېتىراپ',
  'license.features.international.desc': 'سودا ئورنى ئەزالىقى دۇنيادا كەڭ ئېتىراپ قىلىنىپ، خەلقئارالىق ئىشەنچ بېرىدۇ',
  'license.features.market.title': 'بازارغا بىۋاسىتە كىرىش',
  'license.features.market.desc': 'ئەڭ ياخشى بازار سۇيۇقلۇقى بىلەن سودا ئورنى بازىرىغا بىۋاسىتە قاتنىشىش',
  'license.features.network.title': 'كەسىپ تورى',
  'license.features.network.desc': 'كەڭ كەسىپ تورىنىڭ بىر قىسمى بولۇپ، باشقا نازارەت قىلىنىدىغان پۇل-مۇئامىلە ئورۇنلىرى بىلەن ئىشەنچلىك ھەمكارلىق قۇرىدۇ',
  'license.exchange.badge': 'سودا ئورنى ھەققىدە',
  'license.exchange.title': 'شياڭگاڭ ئالتۇن سودىسى ئورنى — بىر ئەسىردىن ئارتۇق مىراس',
  'license.exchange.desc1': 'شياڭگاڭ ئالتۇن سودىسى ئورنى (香港黃金交易所) 1910-يىلى قۇرۇلغان بولۇپ، شياڭگاڭدىكى ئەڭ قەدىمىي قىممەتلىك مېتال سودا ئورنى. بىر ئەسىردىن ئارتۇق ۋاقىتتىن بۇيان شياڭگاڭ ۋە ئاسىيا قىممەتلىك مېتال بازىرىنىڭ يادرولۇق ئورنى بولۇپ كەلدى.',
  'license.exchange.desc2': 'سودا ئورنى قاتتىق ئەزالىق تۈزۈمىنى يولغا قويىدۇ — پەقەت ئەتراپلىق تەكشۈرۈشتىن ئۆتكەن لاياقەتلىك كارخانىلارلا رەسمىي ئەزا بولالايدۇ. شىركىتىمىزنىڭ 10-نومۇرلۇق ئەزالىق سالاھىيىتى كەسپىي ئىقتىدار ۋە ئىناۋىتىمىزنى تولۇق نامايان قىلىدۇ.',
  'license.exchange.stat1.label': 'سودا ئورنى قۇرۇلغان',
  'license.exchange.stat2.label': 'يىللىق مىراس',
  'license.exchange.stat3.label': 'كۈندىلىك سودا مىقدارى',
  'license.exchange.stat4.value': 'دۇنياۋى',
  'license.exchange.stat4.label': 'خەلقئارالىق ئېتىراپ',
  'license.exchange.img.caption': 'شياڭگاڭ ئالتۇن سودىسى ئورنى',
  'license.exchange.img.sub': 'شياڭگاڭدىكى ئالدىنقى قىممەتلىك مېتال سودا ئورنى',
  'license.exchange.badge.number': '10-نومۇرلۇق ئەزا',
  'hero.cta.accountOpening': 'ھېسابات ئېچىش جەريانى',
  'hero.cta.depositWithdraw': 'مەبلەغ سېلىش ۋە ئېلىش جەريانى',
  'androidDownload.title': 'MetaTrader 5 نى چۈشۈرۈڭ',
  'androidDownload.description': 'Google Play غا ئاپتوماتىك يۆتكىلىسىز. ئۈسكۈنىڭىزدە Google Play ئىشلىمىسە، APK نى بىۋاسىتە چۈشۈرەلەيسىز.',
  'androidDownload.autoRedirect': '{{seconds}} سېكۇنتتىن كېيىن Google Play غا يۆتكىلىدۇ',
  'androidDownload.openGooglePlay': 'Google Play نى ئېچىڭ',
  'androidDownload.downloadApk': 'APK نى بىۋاسىتە چۈشۈرۈڭ',
  'androidDownload.hint': 'Google Play ئېچىلمىسا، «APK نى بىۋاسىتە چۈشۈرۈڭ» نى بېسىڭ.',
  'windowsDownload.pageTitle': 'Windows MT5 چۈشۈرۈش',
  'windowsDownload.pageDesc': 'ئۆزىڭىزگە ماس قاچىلاش نەشرىنى تاللاڭ.',
  'windowsDownload.badge': 'Windows MT5 چۈشۈرۈش',
  'windowsDownload.title': 'قاچىلاش بوغچىسىنى تاللاڭ',
  'windowsDownload.description': 'Windows MT5 قاچىلىغۇچنى تاللاڭ. Gold Label راۋان مۇقىم نەشرى جۇڭگو چوڭ قۇرۇقلۇقى ۋە شياڭگاڭ ئىشلەتكۈچىلىرىگە تەۋسىيە قىلىنىدۇ. ئەسلى رەسمىي قاچىلىغۇچنىمۇ ئىشلەتسىڭىز بولىدۇ.',
  'windowsDownload.smoothTitle': '1. Gold Label راۋان مۇقىم نەشرى',
  'windowsDownload.smoothDesc': 'جۇڭگو چوڭ قۇرۇقلۇقى / شياڭگاڭ Windows ئىشلەتكۈچىلىرىگە تەۋسىيە قىلىنىدۇ. باشقا رايوندىكى ئىشلەتكۈچىلەر رەسمىي قاچىلىغۇچ قولايسىز بولسا بۇ نەشرنى ئىشلەتسە بولىدۇ.',
  'windowsDownload.smoothButton': 'Gold Label راۋان مۇقىم نەشرىنى چۈشۈرۈڭ',
  'windowsDownload.officialTitle': '2. MetaQuotes رەسمىي قاچىلىغۇچى',
  'windowsDownload.officialDesc': 'ئەسلى چۈشۈرۈش ئۇلانمىسى. جۇڭگو چوڭ قۇرۇقلۇقىدىكى Windows ئىشلەتكۈچىلىرى بەزىدە قاچىلاش مەسىلىسىگە ئۇچرىشى مۇمكىن؛ باشقا رايونلار تەسىرگە ئۇچرىمايدۇ.',
  'windowsDownload.officialButton': 'رەسمىي قاچىلىغۇچنى چۈشۈرۈڭ',
  'calendar.hongKongTime': 'شياڭگاڭ ۋاقتى (GMT+8)',
  'calendar.to': 'دىن',
  'calendar.noEventsForPeriod': 'بۇ مەزگىلدە ئىقتىسادىي ۋەقە يوق.',
  'calendar.previousDays': 'ئالدىنقى 7 كۈن',
  'calendar.nextDays': 'كېيىنكى 7 كۈن',
  'calendar.today': 'بۈگۈن',
  'calendar.jumpToDate': 'كۈنگە ئاتلاش',
  'calendar.completeView': 'تولۇق كۆرۈنۈش',
  'calendar.allDays': '7 كۈننىڭ ھەممىسى',
  'calendar.events': 'ۋەقە',
  'calendar.impactAll': 'بارلىق تەسىر',
  'calendar.impactHigh': 'يۇقىرى',
  'calendar.impactMedium': 'ئوتتۇرا',
  'calendar.impactLow': 'تۆۋەن',
  'calendar.searchPlaceholder': 'ۋەقە، دۆلەت ياكى پۇل بىرلىكى ئىزدەڭ',
  'calendar.eventsFound': 'ۋەقە كۆرسىتىلدى',
  'calendar.lastUpdated': 'ئاخىرقى يېڭىلانغان ۋاقىت',
  'calendar.loadError': 'ئىقتىسادىي كالېندار ھازىرچە ئىشلىمەيدۇ.',
  'calendar.noEvents': 'بۇ كۆرۈنۈشكە ماس ئىقتىسادىي ۋەقە يوق.',
  'calendar.tryAnotherDate': 'باشقا كۈننى تاللاڭ ياكى سۈزگۈچنى تازىلاڭ.',
  'calendar.time': 'ۋاقىت',
  'calendar.impact': 'تەسىر',
  'calendar.released': 'ئېلان قىلىندى',
  'calendar.pending': 'كۈتۈلۈۋاتىدۇ',
  'calendar.disclaimer': 'كالېندار ۋاقتى شياڭگاڭ ۋاقتى بويىچە. سانلار تۈزىتىلىشى مۇمكىن ۋە پەقەت ئۇچۇر ئۈچۈن تەمىنلىنىدۇ.',
  'news.tab.newsDesc': 'ئەڭ يېڭى بازار خەۋەرلىرى، ئالتۇن تەھلىلى ۋە مائارىپ مەزمۇنى',
  'news.tab.calendarDesc': 'يېقىن كۈنلەردىكى مۇھىم ئىقتىسادىي ۋەقە ۋە ئېلانلارنى كۆرۈڭ',
  'news.autoRefresh': 'خەۋەر ئۇچۇرى ئاپتوماتىك يېڭىلىنىدۇ',
  'news.tabs.news': 'خەۋەرلەر',
  'news.tabs.calendar': 'ئىقتىسادىي كالېندار',
  'news.noCurrentNews': 'ھازىر بازار خەۋىرى يوق.',
};

export default common;
